//@flow

import {useSelector} from 'react-redux';

import {DOWNGRADE_TIERS, MINIMAL_PLANS} from '../../../entities';

import type {StoreInformation, StoreDomain, Store} from '../../../entities';
import type {RootState} from '../..';

const storeSelector = (state: RootState) => state.store.store;

export const useStoreInfo = (): Store | undefined => {
  const store = useSelector(storeSelector);
  return store;
};

const storeInformationSelector = (state: RootState) =>
  state.ui.storeInformation;

export function useStoreInformation(): StoreInformation | undefined {
  const storeInformation = useSelector(storeInformationSelector);
  return storeInformation;
}

const storeDomainSelector = (state: RootState) =>
  (state.store.store && state.store.store.domains) || [];

export function useStoreDomain(): {
  domain: StoreDomain,
  customDomain: StoreDomain | typeof undefined,
  tiendadaDomain: StoreDomain,
} {
  const domains = useSelector(storeDomainSelector);

  const customDomain = domains.find(
    domain => !domain.domainName.includes('tiendada')
  );

  const tiendadaDomain = domains.find(domain =>
    domain.domainName.includes('tiendada')
  );

  return {
    domain: customDomain || tiendadaDomain,
    customDomain,
    tiendadaDomain,
  };
}

export function useStoreBusinessModel() {
  const store = useStoreInfo();
  return store?.storeBusinessModel;
}

export function useStorefrontUrl() {
  const {domain} = useStoreDomain();
  return domain ? `${window.location.protocol}//${domain.domainName}` : '';
}

export function useIsMinimalPlan() {
  const store = useStoreInfo();
  return MINIMAL_PLANS.includes(store?.storeTier.name);
}

export function useIsDowngradeTier() {
  const store = useStoreInfo();
  return DOWNGRADE_TIERS.includes(store?.storeTier.name);
}

const storeMetadataSelector = (state: RootState) => state.store.storeMetadata;

export function useStoreMetadata() {
  return useSelector(storeMetadataSelector)?.metadata;
}

const storePreviousTierSelector = (state: RootState) =>
  state.store.storePreviousTier;

export function useStorePreviousTier() {
  return useSelector(storePreviousTierSelector);
}
